export default {"src":"/uk/_next/static/media/spot-chat.4f8d138f.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};